export default __webpack_public_path__ + "static/media/trans.47888b7c.png";